import React from "react";

const Knowledge = () => {

  const lin = [
    {
      area: "INCOME TAX",
      description: "INCOME TAX",
      website: "https://incometaxindia.gov.in/",
    },
    {
      area:"INCOME TAX",
      description: "Latest Income Tax updates",
      website: "https://www.incometax.gov.in/iec/foportal/latest-news",
    },
    {
      area: "TAX INFORMATION NETWORK",
      description: "TAX INFORMATION NETWORK",
      website: "https://nsdl.co.in/",
    },
    {
      area: "ITAT",
      description: "ITAT",
      website: "https://www.itat.nic.in/",
    },
    {
      area: "TDS",
      description: "TDS",
      website: "https://www.tdscpc.gov.in/",
    },
    {
      area: "GST",
      description: "Goods&service Tax",
      website: "https://www.gst.gov.in/",
    },
    {
      area: "GST",
      description: "Latest GST Update",
      website: "https://services.gst.gov.in/services/advisory/advisoryandreleases",
    },
    {
      area:"CORPORATE LAW",
      description :"MINISTRY OF CORPORATE AFFAIRS (MCA)",
     website:"https://www.mca.gov.in/content/mca/global/en/home.html",
     },
    {
      area:"ICAI",
      description :"OFFICIAL WEBSITE",
     website:"https://www.icai.org/",
     },
     {
      area:"SUPREME COURT",
      description :"OFFICIAL WEBSITE",
     website:"https://www.sci.gov.in/",
     },
     {
      area:"RBI",
      description :"OFFICIAL WEBSITE",
     website:"https://www.rbi.org.in/",
     },
     {
      area:"MINISTRY OF FINANCE",
      description :"OFFICIAL WEBSITE",
     website:"https://finmin.gov.in/",
     },
     {
      area:"PROVIDENT FUND",
      description :"OFFICIAL WEBSITE",
     website:"https://www.epfindia.gov.in/",
     },
     {
      area:"ESIC",
      description :"OFFICIAL WEBSITE",
     website:"https://www.esic.gov.in/",
     },
     {
      area:"CENTRAL BOARD OF INDIRECT TAXES & CUSTOMS",
      description :"OFFICIAL WEBSITE",
     website:"https://www.cbic.gov.in/",
     },
     {
      area:"DIRECTORATE GENERAL OF FOREIGN TRADE",
      description :"OFFICIAL WEBSITE",
     website:"https://www.dgft.gov.in/CP/",
     },
     {
      area:"RIGHT TO INFORMATION",
      description :"OFFICIAL WEBSITE",
     website:"https://rti.gov.in/",
     },
    {
      area: "UDYAM",
      description: "MSME SERVICES",
      website: "https://www.udyamregistration.gov.in",
    },
  ];

  
  const links = [
    {
      area: "Digital Deception The Rising Tide of  Online  Fraud in  India",
      pdf: "/pdfs/income_tax.pdf", // Path to the PDF file
    },
    {
      area: "Reverse Charge Mechanism(RCM)",
      pdf: "/pdfs/RCM basics.pdf", // Path to the PDF file
    },
    {
      area: "Emerging Treads in Indian Startups ",
      pdf: "/pdfs/Start-ups.pdf", // Path to the PDF file
    },
    {
      area: " Introduction to Income Tax Return(ITR)",
      pdf: "/pdfs/ITR.pdf", // Path to the PDF file
    },
    {
      area: "E-commerce - Your Secret Weapon for Exporting",
      pdf: "/pdfs/ONE.pdf", // Path to the PDF file
    },
    {
      area: " Chartered Accountant(CA)",
      pdf: "/pdfs/office.pdf", // Path to the PDF file
    },
  ];

  return (
    <>
      {/* Card Layout */}
      <div className="p-6 mb-20">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-8 he text-center">
         

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {links.map((link, index) => (
              <div
                key={index}
                className="border border-gray-300 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow bg-white"
              >
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  {link.area}
                </h3>
                <p className="text-gray-600 mb-4">{link.description}</p>
                <a
                  href={link.pdf}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-[#005A8C] text-white py-2 px-4 rounded  transition-colors"
                >
                  Open PDF
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Table Layout */}
     
      
      <div className="p-6 mb-20">
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-8 ">
      {/* Title */}
      <h2 className="text-2xl font-bold text-gray-800 mb-2">Useful Links</h2>
      <p className="text-gray-600 mb-6">
        Links which are useful in gathering more information about our work and
        the Indian ecosystem
      </p>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300">
          {/* Table Header */}
          <thead>
            <tr className="bg-[#005A8C] text-white">
              <th className="border border-gray-300 px-4 py-2 text-left">
                Area
              </th>
              <th className="border border-gray-300 px-4 py-2 text-left">
                Description
              </th>
              <th className="border border-gray-300 px-4 py-2 text-left">
                Website Links
              </th>
            </tr>
          </thead>

          {/* Table Body */}
          <tbody>
            {lin.map((link, index) => (
              <tr
                key={index}
                className={`${
                  index % 2 === 0 ? "bg-gray-100" : "bg-white"
                } hover:bg-gray-200`}
              >
                <td className="border border-gray-300 px-4 py-2">
                  {link.area}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {link.description}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-blue-600 underline">
                  <a href={link.website} target="_blank" rel="noopener noreferrer">
                    {link.website}
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
    </div>
    </>
  );
};

export default Knowledge;
